<template>
  <div class="partner-padding">
    <div class="container px-0">
      <div class="page-img">
        <div class="partner-banner-content">
          <h3 class="mb-3">
            <strong>{{ $t('string.beOurPartner') }}</strong>
          </h3>
          <p><strong>{{ $t('partner.subtitle') }}</strong></p>
        </div>
      </div>
    </div>
    <div class="container px-0">
      <div class="partner-content">
        <p
          class="section-title"
          style="font-size: 20px"
        >
          <strong>{{ $t('partner.title.section') }}</strong>
        </p>
        <div class="row">
          <template
            v-if="content_step"
          >
            <div
              class="col-12 col-md-4 mb-4"
              v-for="(item, key) in content_step"
              :key="key"
            >
              <div class="span-icon">
                <img
                  :src="item.icon"
                  alt=""
                  width="30"
                >
              </div>
              <p style="margin-bottom: 15px">
                <strong>{{ $t(item.title) }}</strong>
              </p>
              <p>{{ $t(item.desc) }}</p>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="bg-color" />
    <div class="container px-0">
      <div class="partner-contact">
        <hr>
        <div class="col-12 no-padding">
          <div class="row">
            <div class="col-md-7 mb-4 mb-md-0">
              <p
                class="section-title"
                style="font-size: 20px"
              >
                <strong>{{ $t('string.contactUs') }}</strong>
              </p>
              <p>{{ $t('partner.contact.subtitle') }}</p>
            </div>
            <div class="col-md-5 text-center text-md-right col-button">
              <button
                class="btn btn-outline-cash-hero"
                @click="$router.push({name: 'contact'})"
              >
                {{ $t('string.contactUs') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v3-cash-hero-footer />
  </div>
</template>

<script>
import V3CashHeroFooter from '@/partials/v3/V3CashHeroFooter'

export default {
  name: 'Partner',
  metaInfo: {
    title: 'Be Our Partner',
    titleTemplate: '%s | Cash Hero',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'Be Our Partner' }
    ]
  },
  components: { V3CashHeroFooter },
  data () {
    return {
      content_step: [
        {
          icon: 'img/icons/improving_sale.svg',
          title: 'partner.title.step1',
          desc: 'partner.desc.step1'
        },
        {
          icon: 'img/icons/increase_working.svg',
          title: 'partner.title.step2',
          desc: 'partner.desc.step2'
        },
        {
          icon: 'img/icons/risk.svg',
          title: 'partner.title.step3',
          desc: 'partner.desc.step3'
        }
      ]
    }
  }
}
</script>

<style scoped>
.partner-padding {
  padding-top: 81px
}

.page-img {
  width: 100%;
  position: relative;
  height: 500px;
  margin: 0 auto;
  background-size: cover;
  background-position: center center;
  background-image: url('../../public/img/background/be_our_partner.jpg');
  background-repeat: no-repeat;
  background-blend-mode: overlay;
  background-color: #19171780;
}

.partner-banner-content {
  text-shadow: .3px .3px #2e2e2e;
  color: white;
  position: absolute;
  left: 6%;
  z-index: 3;
  padding-left: 15px !important;
  padding-right: 15px !important;
  top: 250px;
  width: 80%;
  float: left;
}

.partner-content {
  height: 345px;
  padding: 0 40px;
  color: white;
  margin: 84px auto 0;
}

.bg-color {
  width: 100%;
  height: 560px;
  background-color: var(--primary);
  z-index: -1;
  position: absolute;
  top: 450px;
}

.span-icon {
  height: 50px;
  width: 50px;
  border-radius: 50px;
  background: #fff;
  color: var(--primary);
  padding: 2px;
  line-height: 40px;
  text-align: center;
  margin-bottom: 20px;
  font-size: 20px;
  box-shadow: 0 2px 2px 0 rgba(14, 14, 14, 0.1);
}

.partner-contact {
  padding: 5px 40px 30px;
}

.col-button {
  padding-top: 60px;
}

@media screen and (max-width: 991.89px) {
  .page-img {
    height: 365px;
  }

  .partner-banner-content {
    top: 135px;
  }

  .partner-content {
    margin: 70px auto 0;
  }

  .bg-color {
    top: 330px
  }
}

@media screen and (max-width: 767px) {
  .partner-padding {
    padding-top: 71px
  }

  .container {
    margin: 0 !important;
    max-width: 100%;
  }

  .partner-content {
    margin: 60px auto;
    height: 625px;
  }

  .bg-color {
    top: 435px;
    height: 745px;
  }

  .partner-contact {
    padding: 30px 40px;
  }

  .col-button {
    padding-top: 0;
  }
}

@media screen and (max-width: 576px) {
  .partner-banner-content {
    width: 90%;
    top: 50px;
  }
}

@media screen and (max-width: 400px) {
  .page-img {
    height: 415px;
  }

  .partner-content {
    height: 790px;
  }

  .bg-color {
    top: 435px;
    height: 960px;
  }
}
</style>
